<template>
  <div
    @click="$emit('close')"
    class="!tw-fixed !tw-top-0 !tw-left-0 !tw-w-screen !tw-h-screen tw-bg-[#00000057] tw-z-50 tw-flex tw-justify-center tw-items-center"
  >
    <div class="tw-max-w-[600px] tw-bg-white tw-rounded-3xl" @click.stop>
      <video controls v-if="type == 'video'">
        <source :src="preview" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <img :src="preview" v-if="type == 'image'" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    preview: {
      required: false,
    },
    type: {
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
